"use client";
import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import Link from "next/link";

export default function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const [mounted, setMounted] = useState(false);

  // Ensure portal target is available (avoids SSR mismatch)
  useEffect(() => {
    setMounted(true);
  }, []);

  // Prevent scrolling when menu is open
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "unset";
  }, [isOpen]);

  const overlay = isOpen && (
    <div className="fixed inset-0 z-[100] bg-white flex flex-col p-6 md:hidden animate-in fade-in zoom-in-95 duration-200">
      <div className="flex justify-between items-center mb-12">
        <span className="font-h3 text-h3 font-bold tracking-tighter text-primary">
          Shecraa Studio
        </span>
        <button
          onClick={() => setIsOpen(false)}
          className="text-primary p-2 rounded-full hover:bg-surface-container-low transition-colors"
          aria-label="Close menu"
        >
          <span className="material-symbols-outlined text-h3">close</span>
        </button>
      </div>

      <nav className="flex flex-col gap-6 text-center">
        {[
          { name: "Home", href: "/" },
          { name: "Services", href: "/services" },
          { name: "Portfolio", href: "/portfolio" },
          { name: "Market", href: "/market" },
          { name: "Contact", href: "/contact" },
        ].map((link) => (
          <Link
            key={link.href}
            href={link.href}
            onClick={() => setIsOpen(false)}
            className="font-display text-h1 text-primary hover:opacity-70 transition-opacity"
          >
            {link.name}
          </Link>
        ))}
      </nav>

      <div className="mt-auto pt-12 text-center">
        <Link
          href="/contact"
          onClick={() => setIsOpen(false)}
          className="inline-block bg-primary text-on-primary font-label-sm text-label-sm px-8 py-4 rounded uppercase tracking-widest w-full"
        >
          Let&apos;s Talk
        </Link>
      </div>
    </div>
  );

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="md:hidden text-primary hover:bg-surface-container-low p-2 rounded-full transition-colors"
        aria-label="Open menu"
      >
        <span className="material-symbols-outlined text-h3">menu</span>
      </button>

      {mounted && createPortal(overlay, document.body)}
    </>
  );
}